<template>
  <div class="panel">
    <div class="level1">
      <h2 class="level-line1">{{ options.titleCh }}</h2>
      <!-- <div class="fg"></div>
      <h2 class="level-line2">{{ options.titleEn }}</h2> -->
    </div>
    <p class="level2">{{ options.description }}</p>
    <slot name="content"></slot>
  </div>
</template>

<script>
export default {
  name: "panel",
  props: ["content"],
  data() {
    return {
      options: {
        titleCh: "",
        titleEn: "",
        description: "",
      },
    };
  },
  created() {
    this.options = this.content;
  },
};
</script>

<style scoped lang="less">
.panel {
  .level1 {
    display: flex;
    justify-content: center;
    // margin-top: 60px;
    font-weight: bold;
    // letter-spacing: 7px;
    // .fg {
    //   width: 2px;
    //   background-color: #333333;
    //   margin: 0 10px;
    // }
  }
  .level2 {
    // font-size: 16px;
    color: #777777;
    text-align: center;
    // margin: 12px auto 24px;
    // line-height: 22px;
    letter-spacing: 2px;
  }
}
@media screen and (min-width: 1200px) {
  .level1 {
    // font-size: 24px;
    font-size: 38px;
    letter-spacing: 7px;
    margin-top: 60px;
    // .fg {
    //   height: 24px;
    // }
  }
  .level2 {
    margin: 22px auto 50px;
    font-size: 26px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1200px) {
  //ipad pro
    .level1 {
    font-size: 28px;
    letter-spacing: 5px;
    margin-top: 4vh;
    // .fg {
    //   height: 24px;
    // }
  }
  .level2 {
    margin: 18px auto 40px;
    width: 70%;
    line-height: 30px;
    font-size: 18px;
  }
}
@media screen and (min-width: 414px) and (max-width: 768px) {
  //ipad
  .level1 {
    font-size: 22px;
    letter-spacing: 4px;
    margin-top: 4vh;
    // .fg {
    //   height: 20px;
    // }
  }
  .level2 {
    margin: 16px auto 30px;
    width: 70%;
    line-height: 22px;
    font-size: 16px;
  }
}
@media screen and (max-width: 414px) {
  //phone
  .level1 {
    font-size: 18px;
    letter-spacing: 4px;
    margin-top: 3vh;
    // .fg {
    //   height: 18px;
    // }
  }
  .level2 {
    margin: 10px auto 20px;
    // width: 86%;
    width: 92%;
    line-height: 18px;
    font-size: 12px;
  }
}
</style>
